<template>
  <div>
    <page-nav-bar
      v-if="l"
      :is-sticky="true"
      :back-button="true"
      :hide-separators="true"
      :has-actions="canBeOptioned || canBeDenunce || canBeEdited || canBeDeleted || !(isAdmin && isPromoteur)"
      :program-status="lot.program.status">
      <router-link
        slot="title"
        :to="{ name: 'ProgramVue', params: { id: documentEl.program.pk } }">
        {{ documentEl.program.name }}
      </router-link>
      <span slot="subtitle"> / {{ documentEl.ref }}</span>
      <router-link
        slot="label"
        v-if="isDistributeur && isPromoteurDetailsActivated"
        :to="{name: 'PromoteurPresentation', params: {id: documentEl.promoteur.pk}}">
        <span>- {{ documentEl.promoteur.name }}</span>
      </router-link>
      <span
        v-if="isDistributeur && !isPromoteurDetailsActivated"
        slot="label">- {{ documentEl.promoteur.name }}</span>
      <template
        v-if="lot.program.status !== 'archived'"
        slot="before-actions">
        <router-link
          v-if="canBeDenunce"
          class="page-header-btn is-small is-border-left"
          :to="{name: 'DenunciationCreate', query: {lot: documentEl.pk}}">
          <!--<span class="icon"><i class="fas fa-bullhorn"></i></span>-->
          <span class="">Dénoncer contact</span>
        </router-link>
        <router-link
          v-if="canBeOptioned"
          class="page-header-btn is-small is-optioned"
          :to="{name: 'OptionCreate', query: {lot: documentEl.pk}}">
          <!--<span class="icon"><i class="fas fa-flag"></i></span>-->
          <span class="">Optionner ce lot</span>
        </router-link>
      </template>
      <router-link
        v-if="canBeEdited"
        id="lotEditButton"
        slot="dropdown-content"
        :to="{name: 'LotEdit', params: {id: documentEl.pk}}"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-edit" /></span><span class="is-margin-left-xsmall">Modifier fiche</span>
      </router-link>
      <router-link
        v-if="isAdmin && isPromoteur"
        slot="dropdown-content"
        :to="{name: 'LotDuplicate', query: {duplicateLot: documentEl.pk}}"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-clone" /></span><span class="is-margin-left-xsmall">Dupliquer</span>
      </router-link>
      <router-link
        v-if="canBeEdited"
        slot="dropdown-content"
        :to="{name: 'LotEdit', params: {id: documentEl.pk}, query: {panel: 'DOCS'}}"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-folders" /></span><span class="is-margin-left-xsmall">Gestion documents</span>
      </router-link>
      <router-link
        v-if="canBeSale"
        slot="dropdown-content"
        :to="{name: 'SaleForm', params: {id: documentEl.pk}}"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-award" /></span><span class="is-margin-left-xsmall">Déclarer une vente</span>
      </router-link>
      <a
        v-if="!wishlisted"
        slot="dropdown-content"
        class="dropdown-item"
        @click.prevent.stop="addToWishlist">
        <span class="icon is-medium"><i class="fal fa-star" /></span><span class="is-margin-left-xsmall">Ajouter aux favoris</span>
      </a>
      <a
        v-if="wishlisted"
        slot="dropdown-content"
        class="dropdown-item"
        @click.prevent.stop="deleteFromWishlist(l.pk)">
        <span class="icon is-medium"><i class="fas fa-star" /></span><span class="is-margin-left-xsmall">Supprimer des favoris</span>
      </a>
      <!-- <a v-if="isAdmin && isPromoteur" @click="xlsExportUrl" class="dropdown-item"
        slot="dropdown-content">
        <span class="icon"><i class="fas fa-file-export"></i></span><span>Exporter données .XLS</span>
      </a> -->
      <a
        v-if="isAdmin && isPromoteur && canBeDeleted"
        id="lotDeleteButton"
        slot="dropdown-content"
        class="dropdown-item has-background-danger has-text-white"
        @click.prevent.stop="deleteLot(l)">
        <span class="icon is-medium"><i class="fas fa-trash-alt" /></span><span class="is-margin-left-xsmall">Supprimer fiche</span>
      </a>
      <!-- <a v-if="!(isAdmin && isPromoteur)" @click="openModalTicket" slot="dropdown-content" class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-question"></i></span>
        <span>Contacter le promoteur</span>
      </a> -->
    </page-nav-bar>
    <page-content
      v-if="documentEl"
      :has-no-padd-on-act-on-desktop="true"
      :has-padd-left-on-act="true"
      :has-padd-right-on-act="true"
      :has-left-col-small="true"
      :has-left-col-small-size-fixed="false"
      :has-sticky-col-left="true">
      <template slot="left-col-small">
        <div class="has-background-white is-border">
          <div
            class="is-padding-top-xsmall is-padding-left is-padding-right is-padding-bottom-xsmall has-text-centered has-status-bar--left is-border-bottom"
            :class="[`has-status-bar--${documentEl.status}`]">
            <div class="level is-marginless">
              <div class="level-left">
                <div class="level-item">
                  <span class="title is-5 has-text-weight-bold">Statut du lot :</span>
                </div>
                <div
                  v-if="canChangeStatus"
                  class="level-item field">
                  <div class="select is-transparent is-small">
                    <select
                      v-model="documentEl.status"
                      @change="patchLot({status: documentEl.status})">
                      <option
                        v-for="s in statusLotList"
                        :key="s.label"
                        :value="s.value">
                        {{ s.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  v-else
                  class="level-item is-size-5">
                  {{ l.status | statusLabel }}
                </div>
              </div>
            </div>
            <div
              v-if="endDate && documentEl.status === 'optioned'"
              class="has-text-left">
              (Date prévue de disponibilité : <span class="has-text-weight-bold has-text-black">le {{ endDate | dtFormat('DD/MM/YYYY') }}</span>)
            </div>
          </div>
          <!-- <div
            v-if="isAdmin && isPromoteur"
            class="is-padding-top-xsmall is-padding-left is-padding-right is-padding-bottom-xsmall has-text-centered has-status-bar--left is-border-top is-flex-between"
            :class="[`has-status-bar--grey_light`]">
            <div
              class="control is-size-6 is-flex">
              <div
                style="white-space: nowrap"
                class="has-text-weight-bold">
                Visible par :
              </div>
              <div class="is-bloc is-margin-left-xsmall">
                <div>
                  <div>
                    {{ lotVisibility.seller }} Vendeur{{ lotVisibility.seller && lotVisibility.seller > 1 ? 's' : '' }} interne
                    <span
                      class="has-text-weight-semibold is-size-7"
                      v-if="!documentEl.intern_visibility">(Lot masqué)</span>
                  </div>
                </div>
                <div>
                  <div>
                    {{ lotVisibility.prescripteur }} Prescripteur{{ lotVisibility.prescripteur && lotVisibility.prescripteur > 1 ? 's' : '' }}
                    <span
                      class="has-text-weight-semibold is-size-7"
                      v-if="!documentEl.extern_visibility">(Lot masqué)</span>
                  </div>
                </div>
              </div>
            </div>
            <router-link
              v-if="canBeEdited"
              id="lotEditButton"
              class="is-size-6 has-text-grey"
              :to="{name: 'LotEdit', params: { id: documentEl.pk }, query: { panel: 'PARAMS' }}">
              <span class="has-text-hoverable">Modifier</span><span class="icon is-medium"><i class="fal fa-arrow-right is-size-6"></i></span>
            </router-link>
          </div> -->
          <div v-if="documentEl.program && documentEl.program.picture">
            <figure class="image is-margin-auto has-tag has-tag--top-left">
              <span
                v-if="documentEl.program && isAdmin && isPromoteur"
                class="tag is-radiusless"
                :class="documentEl.program.status | programStatusClass">
                {{ documentEl.program.status | workflowLabel }}
              </span>
              <div>
                <img :src="documentEl.program.picture.cloudinary_id | cloudinary({width: 600, height: 350, crop: 'fill'})">
              </div>
            </figure>
          </div>
          <div :class="{'is-border-top is-border--dashed': isAdmin && isPromoteur}">
            <div class="columns is-multiline is-gapless is-marginless">
              <router-link
                :to="{name: 'ProgramVue', params: {id: documentEl.program.pk}}"
                class="column is-12 is-border-bottom is-border--dashed is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right vadBlockHover vadBlockHover--decoration">
                <div class="has-text-grey is-size-6">
                  Programme
                </div>
                <div
                  v-if="documentEl.program.name"
                  class="has-text-primary is-size-4">
                  {{ documentEl.program.name }}
                </div>
                <div v-else>
                  NC
                </div>
                <div
                  v-if="documentEl.program.progress_step"
                  class="is-margin-top-xsmall">
                  <span class="tag is-info">{{ documentEl.program.progress_step | programStepProgressLabel }}</span>
                </div>
              </router-link>
              <div
                v-if="isDistributeur"
                class="column is-12 is-border-bottom is-border--dashed is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <figure
                  v-if="documentEl.promoteur.picture"
                  class="">
                  <img :src="documentEl.promoteur.picture.cloudinary_id | cloudinary({width: 'auto', height: 76, crop: 'fill'})">
                </figure>

                <div class="is-flex is-wrap-flex is-size-6 is-margin-top-xxsmall">
                  <span>Promoteur&nbsp;:&nbsp;</span>
                  <span class="has-text-weight-medium is-margin-right-xsmall">{{ documentEl.promoteur.name }}</span>
                  <!-- <router-link :to="{name: 'CompanyVue', params: {id: documentEl.promoteur.pk}}">
                    <span class="is-underline has-text-weight-medium">{{documentEl.promoteur.name}}</span>
                  </router-link> -->

                  <a
                    v-if="!(isAdmin && isPromoteur)"
                    class="is-underline"
                    @click="openModalTicket">
                    <span class="has-text-weight-medium">Contacter responsable programme</span>
                  </a>
                </div>
              </div>
              <div class="column is-12 is-border-bottom is-border--dashed is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Adresse
                </div>
                <div
                  v-if="documentEl.program.address && documentEl.program.address.zip_code"
                  class="is-margin-top-xsmall has-text-primary is-size-4">
                  {{ documentEl.program.address.line1 }}<br>
                  {{ documentEl.program.address.zip_code }} {{ documentEl.program.address.city }} <i>{{ documentEl.program.address.country }}</i>
                </div>
                <div v-else>
                  NC
                </div>
              </div>
              <div class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Dispositif(s)
                </div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4">
                  {{ taxDispositifs }}
                </div>
              </div>
              <div class="column is-6 is-border-bottom is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Zone
                </div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4">
                  {{ documentEl.program.tax_zone || '--' }}
                </div>
              </div>
              <div class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Actabilité
                </div>
                <div class="is-margin-top-xsmall has-text-primary is-size-4">
                  {{ documentEl.program.date_actabilite || '--' | prettyTrimestre }}
                </div>
              </div>
              <div class="column is-6 is-border-bottom is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Livraison
                </div>
                <div
                  v-if="documentEl.building != null && Object.entries(documentEl.building).length !== 0 && documentEl.building.date_livraison != null"
                  class="is-margin-top-xsmall has-text-primary is-size-4">
                  {{ documentEl.building.date_livraison || '--' | prettyTrimestre }}
                </div>
                <div
                  v-else
                  class="is-margin-top-xsmall has-text-primary is-size-4">
                  {{ documentEl.program.date_livraison || '--' | prettyTrimestre }}
                </div>
              </div>
              <div
                v-if="lotProgram"
                v-scroll-to="'#lotList'"
                class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right vadBlockHover vadBlockHover--decoration">
                <div class="has-text-grey is-size-6">
                  Lot(s) disponible(s)
                </div>
                <div
                  v-if="lotCount"
                  class="is-margin-top-xsmall has-text-primary is-size-4">
                  {{ lotCount }}
                </div>
                <div
                  v-else
                  class="is-margin-top-xsmall has-text-primary is-size-4">
                  --
                </div>
              </div>
              <div class="column is-6 is-border-bottom columns is-column is-border--dashed is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Taux commercialisation
                </div>
                <div
                  v-if="!lotRemunerationLoading"
                  class="is-margin-top-xsmall has-text-primary is-size-4">
                  <div v-if="lotRemuneration && (isDistributeur || currentUser.active_all_contact || isSeller)">
                    {{ lotRemuneration.remuneration + (l.bonus || 0) }} % HT
                  </div>
                  <div v-else-if="lotProgram">
                    {{ lotProgram.remuneration ? lotProgram.remuneration + ' % HT' : '--' }}
                  </div>
                  <div v-else>
                    --
                  </div>
                </div>
              </div>
              <div
                v-if="documentEl.nature === 'field' || isAmenagement"
                class="column is-6 is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Date butoir de dépôt PC
                </div>
                <div
                  v-if="documentEl.pc_depose_date"
                  class="is-margin-top-xsmall has-text-primary is-size-4">
                  {{ documentEl.pc_depose_date || '--' | date }}
                </div>
                <div
                  v-else
                  class="is-margin-top-xsmall has-text-primary is-size-4">
                  {{ deadline_date || '--' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <event-tracker-list
          v-if="isPromoteur"
          :field="'lot'" />
      </template>
      <div
        v-if="isAdmin && isPromoteur || isPromoteur && isManagerPlus"
        v-scroll-to="'#commentSection'"
        class="has-background-primary is-margin-bottom-xsmall is-fullwidth is-flex-between has-text-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small has-cursor-pointer">
        <div class="has-text-weight-semibold is-flex-center">
          <div
            class="is-flex-center comment-icon">
            <span
              v-if="lot.comments && lot.comments.length"
              :style="`border-color: #24323B`"
              class="orange-bullet"></span>
            <span
              class="icon is-size-3 icon-margin">
              <i class="fas fa-sticky-note"></i>
            </span>
          </div>
          <span class="is-margin-left-xsmall">{{ lot.comments.length > 1 ? 'Commentaires' : 'Commentaire' }}</span>
          <span class="is-margin-left-xxsmall">({{ lot.comments.length }})</span>
        </div>
        <div class="is-underline is-size-6 is-margin-right">
          <i>Ajouter un commentaire</i>
        </div>
      </div>
      <div class="has-background-white is-border">
        <div class="columns is-multiline is-gapless is-marginless is-padding">
          <div class="column is-narrow">
            <div class="title is-3 is-uppercase">
              <!-- documentEl.sale_price_ttc -->
              <span class="has-text-grey has-text-weight-normal">N° du lot : </span>
              <b><span id="lotRef">{{ l.ref }}</span> - Prix : <span v-if="lotReservation && lotReservation.sale_price_ttc">{{ lotReservation.sale_price_ttc | prettyPrice }} €</span><span v-else-if="documentEl.sale_price_ttc">{{ documentEl.sale_price_ttc | prettyPrice }} €</span><i
                v-else>NC</i></b>
              <span>
                <router-link
                  v-if="canBeEdited"
                  id="lotEditButton"
                  slot="dropdown-content"
                  :to="{name: 'LotEdit', params: {id: documentEl.pk}}">
                  <span class="is-size-6 is-underline is-margin-left-xsmall has-text-weight-light is-italic">M</span><span class="is-lowercase is-size-6 is-underline has-text-weight-light is-italic">odifier fiche du lot</span>
                  <span class="icon is-padding-left-xsmall is-size-6"><i class="fas fa-arrow-right is-size-6 has-text-weight-light"></i></span>
                </router-link>
              </span>
            </div>
          </div>
          <div
            v-if="documentEl.tags"
            class="is-margin-left column columns is-gapless">
            <div class="column is-narrow">
              <div class="tags">
                <span
                  v-for="(t, i) in documentEl.tags"
                  :key="i"
                  class="tag is-annonce is-small">{{ t }}</span>
              </div>
            </div>
          </div>
        </div>

        <lot-option
          :first-option="firstOption"
          :reservation="lotReservation"
          :waiting-list="waitingList"
          :program="lotProgram"
          :canceled-list="canceledList"
          @openModalTicket="openModalTicket"
          @updateOption="updateLotAndOptions"
          @reloadLotOption="reloadLotOption" />

        <div class="has-background-white--darken1 is-padding-small is-uppercase">
          <span
            v-if="!isParking"
            class="has-text-grey">Dispositif(s) : </span>
          <strong v-if="taxDispositifs && !isParking">{{ taxDispositifs }}</strong>
          <strong v-else-if="!taxDispositifs && !isParking">NC</strong>
          <span class="has-text-grey"><span v-if="!isParking">/</span> Actabilité : </span>
          <strong v-if="documentEl.program && documentEl.program.date_actabilite">{{ documentEl.program.date_actabilite |
            prettyTrimestre }}</strong>
          <strong v-else>NC</strong>
          <span class="has-text-grey">/ Livraison : </span>
          <strong v-if="documentEl.building != null && Object.entries(documentEl.building).length !== 0 && documentEl.building.date_livraison != null">{{ documentEl.building.date_livraison | prettyTrimestre }}</strong>
          <strong v-else>{{ documentEl.program.date_livraison || '--' | prettyTrimestre }}</strong>
        </div>
        <div
          v-if="!documentEl.program.is_optionable"
          class="has-background-annonce is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right is-padding-left">
          <div class="columns is-2 is-variable is-vcentered">
            <!--&& !program.is_optionable -->
            <div class="column is-narrow">
              <span class="icon is-medium has-text-white"><i class="fas fa-engine-warning fa-lg" /></span>
            </div>
            <div class="column">
              <div class="has-text-white is-italic is-size-7 has-text-weight-bold">
                <span>Lot non optionnable <a
                  v-if="!(isPromoteur && isAdmin)"
                  class="has-text-white is-underline"
                  @click="openModalTicket()">(contacter responsable programme)</a></span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="lotAllotment"
          class="has-background-white--darken3 is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right is-padding-left">
          <div class="columns is-gapless is-vcentered">
            <div class="column is-narrow" />
            <div class="column">
              <div class="has-text-white is-uppercase is-size-7 has-text-weight-bold">
                <span>Alloté : {{ lotAllotment }} société(s)</span>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-gapless is-padding is-multiline">
          <div class="column is-4 is-border-right is-border--dashed">
            <h3
              v-if="!isParking"
              class="title is-4 is-margin-bottom-small">
              <b>Caractéristiques du lot</b>
            </h3>
            <h3
              v-else
              class="title is-4 is-margin-bottom-small">
              <b>Caractéristiques du Parking</b>
            </h3>
            <div
              class="has-text-weight-medium">
              <span class="has-text-black">Nature et type :
                <span class="has-text-grey">
                  <span v-if="documentEl.nature">{{ documentEl.nature | natureLabel }}</span><i v-else>NC</i>
                  &nbsp;
                  <span v-if="documentEl.lot_type">{{ documentEl.lot_type | lotTypeLabel }}</span>
                  &nbsp;
                  <span v-if="documentEl.lot_subtype && documentEl.lot_subtype.length">
                    <span
                      v-for="(subtype, i) in documentEl.lot_subtype"
                      :key="i">
                      {{ subtype | lotSubtypeLabel }}
                    </span>
                  </span>
                  <span v-if="!documentEl.lot_type && !documentEl.lot_subtype.length && documentEl.nature !== 'bedroom'"><i>NC</i></span>
                </span>
              </span>
            </div>
            <div
              v-if="!isParking && documentEl.surface"
              class="has-text-weight-medium">
              <span class="has-text-black">Surface :
                <span class="has-text-grey">
                  <span>{{ documentEl.surface | prettyPrice }} m²</span>
                </span>
              </span>
            </div>
            <div
              v-if="!isParking && documentEl.nature === 'field' && documentEl.floor_area"
              class="has-text-weight-medium">
              <span class="has-text-black">Surface plancher :
                <span class="has-text-grey">
                  <span>{{ documentEl.floor_area | prettyPrice }} m²</span>
                </span>
              </span>
            </div>
            <div
              v-if="!isParking && documentEl.nature === 'field' && documentEl.unbuildable_area"
              class="has-text-weight-medium">
              <span class="has-text-black">Dont surface inconstructible :
                <span class="has-text-grey">
                  <span>{{ documentEl.unbuildable_area | prettyPrice }} m²</span>
                </span>
              </span>
            </div>
            <div
              v-if="!isParking && documentEl.nature === 'field' && documentEl.footprint"
              class="has-text-weight-medium">
              <span class="has-text-black">Emprise au sol :
                <span class="has-text-grey">
                  <span>{{ documentEl.footprint | prettyPrice }} m²</span>
                </span>
              </span>
            </div>
            <div
              v-if="!isParking && documentEl.nature === 'field' && documentEl.buildable_area"
              class="has-text-weight-medium">
              <span class="has-text-black">Zone constructible :
                <span class="has-text-grey">
                  <span>{{ documentEl.buildable_area | prettyPrice }} m²</span>
                </span>
              </span>
            </div>
            <div
              v-if="!isParking && documentEl.nature === 'field' && documentEl.waterproofed_surface"
              class="has-text-weight-medium">
              <span class="has-text-black">Surface imperméabilisée :
                <span class="has-text-grey">
                  <span>{{ documentEl.waterproofed_surface | prettyPrice }} m²</span>
                </span>
              </span>
            </div>
            <div
              v-if="!isParking && documentEl.nature === 'field' && documentEl.nb_face"
              class="has-text-weight-medium">
              <span class="has-text-black">Nombre de face(s) :
                <span class="has-text-grey">
                  <span>{{ documentEl.nb_face | nbfaceLabel }}</span>
                </span>
              </span>
            </div>
            <div
              v-if="documentEl.sales_mode && documentEl.sales_mode.length"
              class="has-text-weight-medium">
              <span class="has-text-black">Mode de vente :
                <span class="has-text-grey">
                  <span
                    v-for="(mode, i) in documentEl.sales_mode"
                    :key="i">
                    <span v-if="i === 0">{{ mode | salesmodeLabel }}</span>
                    <span v-else>, {{ mode | salesmodeLabel }}</span>
                  </span>
                </span>
              </span>
            </div>
            <div
              v-if=" lotProgram && lotProgram.use_tranche && documentEl.tranche"
              class="has-text-weight-medium">
              <span class="has-text-black">Tranche :
                <span class="has-text-grey">
                  <span>{{ documentEl.tranche.name }}</span>
                </span>
              </span>
            </div>
            <div
              v-if="!['field'].includes(documentEl.nature) && documentEl.building"
              class="has-text-weight-medium">
              <span class="has-text-black">Bâtiment :
                <span class="has-text-grey">
                  <span>{{ documentEl.building.name }}</span>
                </span>
              </span>
            </div>
            <div
              v-if="['field'].includes(documentEl.nature) && documentEl.building"
              class="has-text-weight-medium">
              <span class="has-text-black">Sous-tranche:
                <span class="has-text-grey">
                  <span>{{ documentEl.building.name }}</span>
                </span>
              </span>
            </div>
            <div
              v-if="!['garden', 'field'].includes(documentEl.nature) && documentEl.floor"
              class="has-text-weight-medium">
              <span class="has-text-black">Etage :
                <span class="has-text-grey">
                  <span>{{ documentEl.floor | floorLabel }}</span>
                </span>
              </span>
            </div>
            <div
              v-if="!isParking && documentEl.exposures && documentEl.exposures.length"
              class="has-text-weight-medium">
              <span class="has-text-black">Orientation :
                <span class="has-text-grey">
                  <span>{{ documentEl.exposures | exposuresLabel }}</span>
                </span>
              </span>
            </div>
            <div
              v-if="!isParking && documentEl.cadastral_reference"
              class="has-text-weight-medium">
              <span class="has-text-black">Ref cadastrale :
                <span class="has-text-grey">
                  <span>{{ documentEl.cadastral_reference }}</span>
                </span>
              </span>
            </div>
            <div
              v-if="documentEl.notary_data"
              class="has-text-weight-medium">
              <span class="has-text-black">Notaire :
                <span class="has-text-grey">
                  <span v-if="documentEl.notary_data.name">{{ documentEl.notary_data.name }}</span>
                  <span v-else-if="documentEl.program.notary_data.name">{{ documentEl.program.notary_data.name }}</span>
                  <i v-else>NC</i>
                </span>
              </span>
            </div>
          </div>
          <div
            v-if="!isParking"
            class="column is-4 is-border-right is-border--dashed is-padding-left-small">
            <h3 class="title is-4 is-margin-bottom-small">
              <b>Annexe / Stationnement / Mobilier</b>
            </h3>
            <div class="has-text-weight-medium">
              <template v-if="annexes && !!Object.values(annexes).length">
                <div
                  v-for="(items, type) in annexes"
                  :key="'annex-'+type"
                  class="has-text-grey has-text-weight-medium">
                  <span
                    v-if="items.count > 1"
                    class="has-text-black">{{ items.count }} </span>
                  <span class="has-text-black">{{ type | annexTypeLabel | cap | pluralize(items.count > 1) }}</span>
                  <span
                    v-if="(items.infos && !!items.infos.length) || items.surface"
                    class="has-text-black"> : </span>
                  <span
                    v-for="i in items.count"
                    :key="i">
                    <span v-if="items.surface && items.surface[i - 1]">{{ items.surface[i - 1] }} m²</span>
                    <span
                      v-if="items.infos && !!items.infos[i - 1]"
                      class="has-text-weight-light">({{ items.infos[i - 1] }})</span>
                    <span v-if="items.count > 1 && i !== items.count"> / </span>
                  </span>
                </div>
              </template>
              <div
                v-for="(type, index) in parking_types"
                :key="index">
                <span
                  v-if="lot.parkings && lot.parkings.filter(x => x.nature.toUpperCase() === type).length"
                  class="has-text-black">
                  {{ lot.parkings.filter(x => x.nature.toUpperCase() === type).length }} {{ type | lotTypeLabel }}{{ lot.parkings.filter(x => x.nature.toUpperCase() === type).length > 1 ? 's' : '' }} :
                </span>
                <template v-if="lot.parkings && lot.parkings.filter(x => x.nature.toUpperCase() === type).length">
                  <span
                    v-for="(p, i) in lot.parkings.filter(x => x.nature.toUpperCase() === type)"
                    :key="i"
                    class="has-text-grey has-text-weight-medium">
                    <span v-if="i > 0"> / </span>
                    <span v-if="p.parking_type && p.parking_type.length">
                      <span
                        v-for="(ptype, j) in p.parking_type"
                        :key="j">{{ j > 0 ? ', ' : '' }}{{ ptype | lotSubtypeLabel }}</span>
                    </span>
                    <span
                      class="has-text-weight-light"
                      v-if="p.sales_mode && p.sales_mode.length || p.floor || p.info"> (
                      <span v-if="p.sales_mode && p.sales_mode.length">
                        <span
                          v-for="(psales_mode, j) in p.sales_mode"
                          :key="j">{{ j > 0 ? ', ' : '' }}{{ psales_mode | salesmodeLabel }}</span>
                      </span>
                      <span v-if="p.floor">{{ p.sales_mode && p.sales_mode.length ? ', ' : '' }}{{ p.floor | floorLabel }}</span>
                      <span v-if="p.info">{{ (p.sales_mode && p.sales_mode.length) || (p.floor) ? ', ' : '' }}{{ p.info }} </span>
                      )
                    </span>
                    <span
                      v-if="p.sale_price_ttc">Prix : {{ p.sale_price_ttc | prettyPrice }}€</span>
                    <span
                      class="has-text-grey has-text-weight-light"
                      v-if="p.sale_price_ht"> ({{ p.sale_price_ht | prettyPrice }} € HT )</span>
                  </span>
                </template>
              </div>
              <div>
                <template v-if="lot && lot.furnitures && lot.furnitures.length">
                  <span class="has-text-black">{{ lot.furnitures.length }} Meuble{{ lot.furnitures.length > 1 ? 's':'' }} : </span>
                  <span
                    v-for="(furniture, index) in lot.furnitures"
                    :key="'furniture' + index">
                    <span class="has-text-grey has-text-weight-medium">{{ furniture.ref }} </span>
                    <span
                      class="has-text-weight-light has-text-grey"
                      v-if="furniture.info"> ({{ furniture.info }}) </span>
                    <span v-if="lot.furnitures.length > 1 && index !== lot.furnitures.length - 1"></span>
                    <span
                      class="has-text-grey"
                      v-if="furniture.sale_price_ttc"> Prix : {{ furniture.sale_price_ttc }}€</span>
                    <span
                      class="has-text-grey has-text-weight-light"
                      v-if=" furniture.sale_price_ht && lot.furnitures.length > 1"> ({{ furniture.sale_price_ht | prettyPrice }} € HT ) /</span>
                    <span
                      class="has-text-grey has-text-weight-light"
                      v-if="furniture.sale_price_ht && lot.furnitures.length == 1"> ({{ furniture.sale_price_ht | prettyPrice }} € HT ) </span>
                  </span>
                </template>
              </div>
              <i v-if="(!annexes || !Object.values(annexes).length) && (!parkings || !parkings.totalCount) && (!furnitures || !Object.values(furnitures).length)">NC</i>
            </div>
          </div>
          <div class="column is-4 is-padding-left-small">
            <h3 class="title is-4 is-margin-bottom-small">
              <b>Prix / Loyer</b>
            </h3>
            <div class="has-text-weight-medium">
              <span class="has-text-black">Prix TTC :
                <span class="has-text-grey">
                  <span v-if="documentEl.sale_price_ttc">{{ documentEl.sale_price_ttc | prettyPrice }} €</span>
                  <i v-else>NC</i>
                </span>
              </span>
            </div>
            <div
              v-if="!documentEl.tva_on_marge"
              class="has-text-weight-medium">
              <span class="has-text-black">Prix HT :
                <span class="has-text-grey">
                  <span v-if="documentEl.sale_price_ht">
                    {{ documentEl.sale_price_ht | prettyPrice }} €<i class="has-text-weight-light"> (TVA {{ documentEl.sale_price_ht | tva(documentEl.sale_price_ttc) | prettyPrice }} %)</i>
                  </span>
                  <i v-else>NC</i>
                </span>
              </span>
            </div>
            <div
              v-if="documentEl.tva_on_marge"
              class="has-text-weight-medium">
              <span>
                <i class="is-size-6">(TVA SUR MARGE APPLIQUÉE)</i>
              </span>
            </div>
            <div
              v-if="!isParking"
              class="has-text-weight-medium">
              <span class="has-text-black">Loyer marché :
                <span class="has-text-grey">
                  <span v-if="documentEl.rent">{{ documentEl.rent | prettyPrice }} €</span>
                  <i v-else>NC</i>
                </span>
              </span>
            </div>
            <div
              v-if="!isParking"
              class="has-text-weight-medium">
              <span class="has-text-black">Rentabilité :
                <span class="has-text-grey">
                  <span v-if="documentEl.profitability">{{ documentEl.profitability | prettyPrice }} %</span>
                  <i v-else>NC</i>
                </span>
              </span>
            </div>
          </div>
          <template v-if="documentEl.pack_list && documentEl.pack_list.length">
            <div
              v-for="(pack, i) in documentEl.pack_list"
              :key="i"
              class="column is-12 is-margin-top">
              <div class="is-padding is-border is-border--white is-border--darken2 is-radius-large has-background-light">
                <h3 class="title is-4 is-marginless-bottom is-uppercase">
                  <b>{{ pack.name }}</b>
                </h3>
                <div class="columns is-mobile is-gapless">
                  <div class="column is-6">
                    <span class="has-text-weight-medium">Prix HT :</span>
                    <span class="has-text-grey">
                      <span v-if="pack.sale_price_ht">
                        {{ pack.sale_price_ht | prettyPrice }} €
                        <i class="has-text-weight-light">
                          (TVA {{ pack.sale_price_ht | tva(pack.sale_price_ttc) | prettyPrice }} %)
                        </i>
                      </span>
                      <i v-else>NC</i>
                    </span>
                  </div>
                  <div class="column is-6">
                    <span class="has-text-weight-medium">Prix TTC :</span>
                    <span class="has-text-grey">
                      <span v-if="pack.sale_price_ttc">
                        {{ pack.sale_price_ttc | prettyPrice }} €
                      </span>
                      <i v-else>NC</i>
                    </span>
                  </div>
                </div>
                <div class="columns is-mobile is-gapless">
                  <div class="column is-6">
                    <span class="has-text-weight-medium">Date début :</span>
                    <span class="has-text-grey">
                      <span v-if="pack.start_date">
                        {{ pack.start_date | date }} €
                      </span>
                      <i v-else>NC</i>
                    </span>
                  </div>
                  <div class="column is-6">
                    <span class="has-text-weight-medium">Date fin :</span>
                    <span class="has-text-grey">
                      <span v-if="pack.end_date">
                        {{ pack.end_date | date }} €
                      </span>
                      <i v-else>NC</i>
                    </span>
                  </div>
                </div>
                <div
                  class="has-text-weight-medium has-text-grey"
                  v-html="pack.description" />
              </div>
            </div>
          </template>
          <div
            v-if="documentEl.capped_profitability || documentEl.capped_rent"
            class="column is-12 is-margin-top">
            <h3 class="title is-4 is-margin-bottom-small">
              <b>Informations complémentaires</b>
            </h3>
            <div
              v-if="documentEl.capped_profitability"
              class="has-text-weight-medium">
              <span class="has-text-black">Rentabilité plafonné :
                <span class="has-text-grey"><span>{{ documentEl.capped_profitability | prettyPrice }} %</span></span>
              </span>
            </div>
            <div
              v-if="documentEl.capped_rent"
              class="has-text-weight-medium">
              <span class="has-text-black">Loyer plafonné :
                <span class="has-text-grey">
                  <span>{{ documentEl.capped_rent | prettyPrice }} €</span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="is-margin">
          <div class="field is-grouped">
            <div
              v-if="programLots && programLots.length"
              class="control is-expanded">
              <a
                v-scroll-to="'#lots'"
                class="button is-small is-black is-rounded is-transform-none is-padding-left-large is-padding-right-large is-fullwidth">
                Les autres lots du programme
              </a>
            </div>
            <div
              v-if="brochureDocument && brochureDocument.path"
              class="control is-expanded">
              <a
                target="_blank"
                :href="brochureDocument.path"
                :download="brochureDocument.filename"
                class="button is-small is-dark is-outlined is-rounded is-transform-none is-padding-left-large is-padding-right-large is-fullwidth">
                <span class="icon is-small"><i class="fas fa-book-open" /></span><span>Brochure programme</span>
              </a>
            </div>
            <div
              v-if="reservationDocument && reservationDocument.path"
              class="control is-expanded">
              <a
                target="_blank"
                :href="reservationDocument.path"
                :download="reservationDocument.filename"
                class="button is-small is-dark is-outlined is-rounded is-transform-none is-padding-left-large is-padding-right-large is-fullwidth">
                <span class="icon is-small"><i class="fas fa-file-signature" /></span><span>Contrat réservation</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        id="documents"
        class="has-background-white is-border is-margin-top-large">
        <tabs
          :level="1"
          :is-fullwidth="true"
          :links="lotDocumentTabsLinks"
          :current-tab="lotDocumentTab"
          mode="emitter"
          class="is-border-bottom"
          @changeView="lotDocumentTab = $event" />
        <component
          :is="['LotDocs', 'ProgramDocs'].includes(lotDocumentTab) ? 'DocumentList' : 'LotPlan'"
          v-if="lotProgram && documentEl"
          :lot="documentEl"
          :document-name="documentName"
          :source-documents="documentsToDisplay" />
      </div>
      <div
        v-if="programLots"
        id="lots"
        class="has-background-light is-border is-padding-bottom-xsmall is-margin-top-large">
        <div class="is-padding has-background-white is-border-bottom">
          <div class="title is-5 is-uppercase">
            Autre<span v-if="programLots.length > 0">s</span> lot<span v-if="programLots.length > 0">s</span> du
            programme {{ lotProgram ? lotProgram.name : '' }}
          </div>
        </div>
        <tabs
          :level="1"
          :is-fullwidth="true"
          :links="lotListLinks"
          :current-tab="lotListTab"
          mode="emitter"
          class="has-background-white is-border-bottom"
          @changeView="lotListTab = $event" />
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall is-padding-left is-padding-right">
          <div class="columns is-variable is-2 is-vcentered">
            <div
              v-for="s in profilAvailableStatus"
              :key="s.value"
              class="column is-narrow is-size-6 is-flex"
              :for="s.value">
              <span
                class="dot is-small is-self-centered is-margin-right-xxsmall"
                :class="s.value|programStatusClass" />
              <span>{{ s.label }}</span>
            </div>
          </div>
        </div>
        <lot-list
          id="lotList"
          class="is-margin-bottom-large"
          :is-lot-view="true"
          :is-loading="loading"
          :no-more-result="getNoMoreResult()"
          :source-lots="getSourceLot()"
          :is-parking="lotListTab === 'Parking'"
          :is-other="lotListTab === 'Autre'"
          @sort="sort"
          @infiniteParking="getProgramParkings"
          @infiniteLot="getProgramLots"
          @infiniteAutre="getProgramAutres" />
        <pagination
          :loading="loading"
          :current-page="currentPage"
          :total-page="totalPage"
          @changePage="loadData($event)"></pagination>
      </div>
      <div
        v-if="isAdmin && isPromoteur || isPromoteur && isManagerPlus"
        class="has-background-white-bis is-padding is-margin-top-small">
        <div
          v-if="lot.comments && lot.comments.length"
          class="has-background-white-bis">
          <div class="row-width-actions-bar columns is-gapless is-marginless">
            <div class="column is-self-centered is-padding-top-xxsmall is-padding-bottom-xxsmall has-background-white-bis">
              <span class="title is-6">
                <span class="is-uppercase is-margin-right-xsmall">{{ lot.comments.length > 1 ? 'Commentaires' : 'Commentaire' }}</span>
                <i class="is-size-7 has-text-weight-normal">(Visible uniquement par les administrateurs de votre société)</i>
              </span>
            </div>
          </div>
          <div
            v-for="(comment, index) in lot.comments"
            :key="index"
            class="is-margin-top-large is-margin-bottom-large has-background-white-bis">
            <div
              v-if="openedComment === index"
              class="is-border-top columns is-gapless">
              <div class="column">
                <wysiwyg-editor
                  :light="true"
                  :tooltip-top="true"
                  :model="comment.text"
                  @change="val => comment.text = val"
                  class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
                </wysiwyg-editor>
              </div>
              <div class="actionsOnRow actionsOnRow--vertical">
                <div>
                  <button
                    @click="comment.date = moment().format(); patchLotComment('modifié'); baseLotComment = null; openedComment = null"
                    type="button"
                    class="button"
                    :class="[(baseLotComment !== comment) ? 'is-success' : 'is-info']"
                    :disabled="!comment.text || (baseLotComment === comment.text) || loadLotComment">
                    <span class="icon is-small">
                      <i
                        v-if="loadLotComment"
                        class="fas fa-spinner fa-spin"></i>
                      <i
                        v-else
                        class="fal fa-save"></i>
                    </span>
                  </button>
                </div>
                <div class="">
                  <button
                    :disabled="!baseLotComment"
                    type="button"
                    :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                    @click="openedComment = null; comment.text = baseLotComment; baseLotComment = null">
                    <span class="icon is-small"><i class="fal fa-times"></i></span>
                  </button>
                </div>
              </div>
            </div>
            <div
              v-else
              @click="openWysiwyg(index)"
              class="vadDiscussion is-border-top"
              style="cursor: pointer;">
              <div
                class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
                <div
                  class="content"
                  v-html="comment.text"></div>
              </div>
            </div>
            <div class="is-flex-between is-margin-top-xxsmall has-background-white-bis">
              <div>
                <span class="is-size-6 has-text-weight-semibold is-margin-right-small">Date : <span class="has-text-weight-normal">{{ comment.date | prettyFullDatetime }}</span></span>
                <span class="is-size-6 has-text-weight-semibold">Auteur : <span class="has-text-weight-normal">{{ comment.user_first_name }} {{ comment.user_last_name }}</span></span>
              </div>
              <div>
                <span
                  @click="openWysiwyg(index)"
                  v-if="(currentUser.pk === comment.user_pk || isAdmin || isManagerPlus) && openedComment === null"
                  class="is-size-6 is-underline is-margin-right-small has-cursor-pointer"><i>Modifier</i></span>
                <span
                  @click="deleteLotComment(index)"
                  v-if="(currentUser.pk === comment.user_pk || isAdmin || isManagerPlus)&& openedComment === null"
                  class="is-size-6 is-underline has-cursor-pointer"><i>Supprimer</i></span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="has-background-white">
          <div class="row-width-actions-bar columns is-gapless is-marginless">
            <div class="column has-background-white-bis is-self-centered is-padding-top-xsmall is-padding-bottom-xsmall">
              <span class="is-uppercase title is-6">Ajouter commentaire</span>
              <i
                v-if="lot.comments && !lot.comments.length"
                class="is-size-7 has-text-weight-normal is-padding-left-xsmall">(Visible uniquement par les administrateurs de votre société)</i>
            </div>
            <div class="column is-narrow">
            </div>
          </div>
          <template>
            <div
              class="is-border-top columns is-gapless">
              <div class="column">
                <wysiwyg-editor
                  ref="commentSection"
                  id="commentSection"
                  :light="true"
                  :tooltip-top="true"
                  :model="lotComment"
                  @change="val => lotComment = val"
                  class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
                </wysiwyg-editor>
              </div>
              <div class="actionsOnRow actionsOnRow--vertical">
                <div>
                  <button
                    @click="addLotComment()"
                    type="button"
                    class="button"
                    :class="[(baseLotComment !== lotComment) ? 'is-success' : 'is-info']"
                    :disabled="!lotComment || loadLotComment">
                    <span class="icon is-small">
                      <i
                        v-if="loadLotComment"
                        class="fas fa-spinner fa-spin"></i>
                      <i
                        v-else
                        class="fal fa-save"></i>
                    </span>
                  </button>
                </div>
                <div class="">
                  <button
                    :disabled="!lotComment"
                    type="button"
                    :class="{'actionsOnRow-btn--hoverIsDanger': lotComment}"
                    @click="lotComment = null">
                    <span class="icon is-small"><i class="fal fa-times"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <cta-to-promoteur
        v-if="!(isPromoteur && isAdmin)"
        class="is-sticky--bottom is-margin-left-auto is-margin-right is-margin-top"
        @clickOnCta="openModalTicket" />
    </page-content>
  </div>
</template>

<script>
import { bus, EVENTS } from '@/bus'
import LotMixin from './LotMixin'
import { isNil } from 'lodash'
import { Sort } from '@/mixins'
import { AnalyticEvent, logAnalyticEvent, setCurrentScreen } from '../../firebaseApp'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import Ajv from 'ajv'
import Vue from 'vue'
import { LOT_TYPES } from '../../mixins/DefaultValues'

Vue.prototype.moment = moment

export default {
  name: 'LotVue',
  components: {
    LotPlan: () => import('./LotPanels/LotPlan'),
    DocumentList: () => import('@/components/utils/DocumentList'),
    LotList: () => import('@/components/stock/LotList'),
    LotOption: () => import('./LotOption'),
    CtaToPromoteur: () => import('@/components/utils/CtaToPromoteur')
  },
  mixins: [LotMixin, Sort],
  data () {
    return {
      loadDocuments: this.getProgramLots,
      loading: false,
      sortBy: {},
      deadline_date: null,
      isAmenagement: false,
      lotPage: 1,
      parkingPage: 1,
      autrePage: 1,
      programLotsCount: 0,
      programParkingsCount: 0,
      programAutresCount: 0,
      currentPage: null,
      totalPage: null,
      lotsList: [],
      parkingsList: [],
      autresList: [],
      lotComment: null,
      baseLotComment: null,
      loadLotComment: false,
      openedComment: null,
      parking_types: []
    }
  },
  computed: {
    ...mapGetters(['accounts, isAdmin', 'isPromoteur', 'isSeller', 'isManagerPlus']),
    ...mapState(['currentUser']),
    isPromoteurDetailsActivated () {
      if (this.accounts && this.accounts.length) return this.accounts.find(a => a.name === this.documentEl.promoteur.name).promoteur_details_activated
      else return false
    },
    endDate () {
      if (this.documentEl.options.length) {
        return this.documentEl.options[this.documentEl.options.length - 1].end_date
      } else return null
    },
    lotListLinks () {
      return [
        { link: 'Logement', label: `${this.programLotsCount} logement(s)` },
        { link: 'Parking', label: `${this.programParkingsCount} stationnement(s)` },
        { link: 'Autre', label: `${this.programAutresCount} autre(s)` }
      ]
    },
    lotDocumentTabsLinks () {
      return [
        { link: 'LotPlan', label: 'Plan du lot' },
        {
          link: 'LotDocs',
          label: 'Documents du lot',
          display: !!this.lot && !!this.lot.documents && !!this.lot.documents.filter(x => x.destination && x.destination.includes('lot')).length && !!this.lot.documents.filter(x => x.destination && x.destination.includes('lot')).length
        },
        {
          link: 'ProgramDocs',
          label: 'Documents du programme',
          display: !!this.lotProgram && !!this.lotProgram.documents && !!this.lotProgram.documents.filter(x => x.destination && x.destination.includes('program')) && !!this.lotProgram.documents.filter(x => x.destination && x.destination.includes('program')).length
        }
      ]
    },
    canBeDeleted () {
      const okStatus = ['available', 'draft', 'archived']
      return !isNil(this.documentEl) && this.isAdmin && this.isPromoteur && okStatus.includes(this.documentEl.status)
    },
    statusLotList () {
      return this.statusList.filter(x => ['available', 'draft'].includes(x.value))
    },
    canChangeStatus () {
      const okStatus = ['available', 'draft', 'archived']
      return okStatus.includes(this.documentEl.status) && this.isAdmin && this.isPromoteur
    },
    documentName () {
      if (this.lotDocumentTab === 'LotDocs') {
        return `des documents du lot ${this.documentEl.ref} du programme ${this.documentEl.program.name}`
      } else if (this.lotDocumentTab === 'ProgramDocs') {
        return `des documents du programme ${this.documentEl.program.name}`
      } else return 'des documents'
    },
    documentsToDisplay () {
      if (this.lotDocumentTab === 'LotDocs') return this.documentEl.documents.filter(x => x.destination && x.destination.includes('lot'))
      else return this.lotProgram.documents.filter(x => x.destination && x.destination.includes('program'))
    }
  },
  watch: {
    '$route.params.id' () {
      this.initView()
      this.sendAnalyticsEvent()
    },
    'lotProgram' () {
      if (this.lotProgram.construction_data.deadline_pc_date != null) {
        this.deadline_date = moment(this.lotProgram.construction_data.deadline_pc_date).format('DD-MM-YYYY')
      }
      this.isAmenagement = this.lotProgram.is_amenagement
    }
  },
  created () {
    bus.$on(EVENTS.OPTION_UPDATED, this.updateLotAndOptions)
    bus.$on(EVENTS.OPTION_CANCELED, this.updateLotAndOptions)
    bus.$on(EVENTS.OPTION_EXTENDED, this.updateLotAndOptions)
    bus.$on(EVENTS.OPTION_CREATED, this.updateLotAndOptions)
    this.sendAnalyticsEvent()
    setCurrentScreen('lot_page')
    this.initPagination()
    // console.log(LOT_TYPES.some(v => v.includes(x => x.show === 'parking')))
    for (const [key, value] of Object.entries(LOT_TYPES)) {
      if (value.show.includes('parking')) this.parking_types.push(key)
    }
  },
  updated () {
    this.initPagination()
    this.params = this.$route.params
    if (this.params && this.params.redirect === 'True') {
      if (this.lotProgram && this.documentEl.pk === this.params.id) {
        this.openModalTicket()
      }
    }
  },
  beforeDestroy () {
    bus.$off(EVENTS.OPTION_UPDATED)
    bus.$off(EVENTS.OPTION_CANCELED)
    bus.$off(EVENTS.OPTION_EXTENDED)
    bus.$off(EVENTS.OPTION_CREATED)
  },
  destroyed () {
    bus.$off(EVENTS.OPTION_UPDATED)
    bus.$off(EVENTS.OPTION_CANCELED)
    bus.$off(EVENTS.OPTION_EXTENDED)
    bus.$off(EVENTS.OPTION_CREATED)
  },
  methods: {
    openWysiwyg (index) {
      if (this.openedComment === null && (this.currentUser.pk === this.lot.comments[index].user_pk || this.isAdmin || this.isManagerPlus)) {
        this.openedComment = index
        this.baseLotComment = this.lot.comments[index].text
      }
    },
    addLotComment () {
      if (this.lotComment) {
        this.lot.comments.push({
          user_pk: this.currentUser.pk,
          user_first_name: this.currentUser.first_name,
          user_last_name: this.currentUser.last_name,
          text: this.lotComment,
          date: moment().format()
        })
        this.lotComment = null
        this.patchLotComment()
      } else {
        this.$toasted.global.danger('Veuillez renseigner un commentaire')
      }
    },
    async deleteLotComment (i) {
      let value = await this.$swal({
        title: 'Suppression commentaire',
        text: 'Confirmer la suppression du commentaire',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value && value.dismiss) return false
      else if (value.value && i >= 0) {
        this.lot.comments.splice(i, 1)
        this.patchLotComment('supprimé')
      }
    },
    async patchLotComment (type = 'ajouté') {
      this.loadLotComment = true
      try {
        const schema = {
          type: 'object',
          properties: {
            user_pk: { type: 'string' },
            user_first_name: { type: 'string' },
            user_last_name: { type: 'string' },
            text: { type: 'string' },
            date: { type: 'string' }
          },
          required: ['user_pk', 'user_first_name', 'user_last_name', 'text', 'date'],
          additionalProperties: false
        }
        const validate = new Ajv().compile(schema)
        for (let i = 0; i < this.lot.comments.length; i++) {
          const el = this.lot.comments[i]
          const valid = validate(el)
          if (!valid) {
            this.loadLotComment = false
            return this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
          }
        }
        await this.$api.patch(this.$resources.LOT, this.lot.pk, { comments: this.lot.comments })
        this.loadLotComment = false
        this.$toasted.global.success(`Commentaire ${type}`)
      } catch (e) {
        console.log(e)
        this.loadLotComment = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    loadData ($event) {
      if (this.lotListTab === 'Logement') {
        this.getProgramLots($event)
      } else if (this.lotListTab === 'Parking') {
        this.getProgramParkings($event)
      } else if (this.lotListTab === 'Autre') {
        this.getProgramAutres($event)
      }
    },
    initPagination () {
      if (this.lotListTab === 'Logement') {
        this.totalPage = this.lotPages
        this.currentPage = this.currentLotPage
      } else if (this.lotListTab === 'Parking') {
        this.totalPage = this.parkingPages
        this.currentPage = this.currentParkingPage
      } else if (this.lotListTab === 'Autre') {
        this.totalPage = this.autrePages
        this.currentPage = this.currentAutrePage
      }
    },
    async getProgramLots (page = 1) {
      let params = {
        program: this.lot.program.pk,
        page,
        per_page: 50,
        nature: ['lot', 'flat', 'house', 'field', 'commercial', 'office', 'bedroom']
      }
      this.loading = true
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.lotsList = data.items
        this.programLotsCount = data.count
        this.lotPages = data.pages
        this.currentLotPage = data.page
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de la récupération des lots !')
      } finally {
        this.loading = false
      }
    },
    async getProgramParkings (page = 1) {
      this.noParkingMoreResult = false
      this.loading = true
      let params = {
        program: this.lot.program.pk,
        page,
        per_page: 50,
        nature: ['parking']
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.parkingsList = data.items
        this.programParkingsCount = data.count
        this.parkingPages = data.pages
        this.currentParkingPage = data.page
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async getProgramAutres (page = 1) {
      this.noAutreMoreResult = false
      this.loading = true
      let params = {
        program: this.lot.program.pk,
        page,
        per_page: 50,
        nature: ['garden', 'annexe']
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.autresList = data.items
        this.programAutresCount = data.count
        this.autrePages = data.pages
        this.currentAutrePage = data.page
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    sendAnalyticsEvent () {
      logAnalyticEvent(AnalyticEvent.PAGE_VIEW, {
        'lot_pk': this.$route.params.id,
        'page_title': 'LotVue',
        'page_page': this.$route.path,
        'page_location': this.$route.fullPath
      })
    },
    openModalTicket () {
      if (!(this.isPromoteur && this.isAdmin)) {
        const formatedReferents = this.lotProgram.referents.map(x => {
          return {
            ...x,
            picture: x.picture[0]
          }
        })
        let params = {
          defaultSubject: 'lot_information',
          defaultTitle: `Lot ${this.documentEl.ref} - Programme ${this.documentEl.program.name}`,
          promoteur: this.documentEl.promoteur.pk,
          referents: formatedReferents || []
        }
        this.$store.commit('setModal', { mode: 'CREATE_TICKET', params })
      }
    },
    async updateLotAndOptions () {
      this.getLotOptions()
      if (this.lotPk) {
        this.notLoadLotsList = true
        await this.getLot(this.lotPk)
        this.notLoadLotsList = false
      }
    },
    getSourceLot () {
      switch (this.lotListTab) {
        case 'Parking':
          return this.parkingsList
        case 'Autre':
          return this.autresList
        default:
          return this.lotsList
      }
    },
    getNoMoreResult () {
      switch (this.lotListTab) {
        case 'Parking':
          return this.noParkingMoreResult
        case 'Autre':
          return this.noAutreMoreResult
        default:
          return this.noMoreResult
      }
    }
  }
}
</script>
